export default __webpack_public_path__ + "static/media/gloria_anthony.f0da0390.jpg";